import { actingOf } from '@alphadesk/ontology/objects/notification.ts';
import type { WireNotification } from '@alphadesk/web/contract.ts';

export interface Thread {
  recommendationId: number | null;
  rows: [WireNotification, ...WireNotification[]];
}

/**
 * The inbox's cards, placed by their newest note, as a recommendation's Telegram message is kept.
 * An alarm stands alone, so its warning is never folded into a line, as does an unanswered ask
 * whose button the card would not show.
 */
export function threadsOf(rows: readonly WireNotification[]): Thread[] {
  const threads: Thread[] = [];
  const open = new Map<number, Thread>();
  for (const row of rows) {
    const about = row.about?.recommendationId ?? null;
    const thread = about === null || row.voice === 'alarm' ? undefined : open.get(about);
    const acting = thread && actingOf(thread.rows);
    const asksApart =
      row.voice === 'ask' &&
      row.readAt === null &&
      acting !== undefined &&
      acting.href !== row.href;
    if (thread !== undefined && !asksApart) {
      thread.rows.push(row);
      continue;
    }
    const started: Thread = { recommendationId: about, rows: [row] };
    threads.push(started);
    if (about !== null && row.voice !== 'alarm' && thread === undefined) open.set(about, started);
  }
  return threads;
}
